import {useMemo} from 'react';

import {useAnnotationModeStore} from './AnnotationModeStore';
import type {QuestionNote} from './annotationNotes';
import {collectQuestionNotes} from './annotationNotes';

/**
 * The notes on the active question, in reading order. The selectors return raw
 * store maps so the snapshots stay cached; the allocation happens in the memos.
 */
export function useQuestionNotes(questionId: string | undefined): QuestionNote[] {
  const annotationsByRegionId = useAnnotationModeStore((state) => state.annotationsByRegionId);
  const mountedSupplements = useAnnotationModeStore((state) => state.mountedSupplements);

  // Mount order is on-screen order; a dual-mounted supplement still lists once.
  const supplementRegionIds = useMemo(
    () => [...new Set(mountedSupplements.map(({regionId}) => regionId))],
    [mountedSupplements]
  );

  return useMemo(
    () => collectQuestionNotes(annotationsByRegionId, questionId, supplementRegionIds),
    [annotationsByRegionId, questionId, supplementRegionIds]
  );
}
